export const TON_DATA_API = "https://tontraders.com/api/v1";

// export const TON_DATA_API = 'http://0.0.0.0:8085/api/v1'